// extracted by mini-css-extract-plugin
export default {"footerStyle":"Footer_footerStyle__CDDXf"};